
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/v3",
      function () {
        return require("private-next-pages/info/v3/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/v3"])
      });
    }
  